export const disabledButtonSx = (theme) => ({
  '&.Mui-disabled': {
    backgroundColor: theme.palette.tertiary.main,
    color: '#000000',
    opacity: 0.4,
  },
});
